import http from "./http-common";
import authHeader from "./auth-header";

const getAll = (params) => {
  return http.get("/customers", { params,headers: authHeader() });
};

const get = (id) => {
  return http.get(`/customers/${id}`,{ headers: authHeader() });
};

const create = (data) => {
   
  return http.post("/customers", data,{ headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/customers/${id}`, data,{ headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/customers/${id}`,{ headers: authHeader()});
};

const removeAll = () => {
  return http.delete(`/customers`);
};

/* const findByTitle = (title) => {
  return http.get(`/tutorials?title=${title}`);
}; */

const findByTitle = (title) => {
  return http.get(`/stock?code=${title}`);
};

const CustomersService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default CustomersService;
